import { render, staticRenderFns } from "./AdminSelectClientModal.vue?vue&type=template&id=10d69750"
import script from "./AdminSelectClientModal.vue?vue&type=script&lang=js"
export * from "./AdminSelectClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports